import Main from './components/Main'
import './css/styles.css'

function App() {
  return (
    <Main />
  );
}

export default App;
